import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutDashboard, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { useAuth } from '../../contexts/AuthContext';

export const AdminQuickAccess = () => {
  const { isAdmin } = useAuth();

  if (isAdmin) {
    return (
      <div className="fixed bottom-6 right-6 z-40">
        <Link to="/admin">
          <Card className="shadow-xl hover:shadow-2xl transition-smooth bg-gradient-primary">
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                  <LayoutDashboard className="w-5 h-5 text-white" />
                </div>
                <div className="text-white">
                  <p className="font-semibold text-sm">Admin Dashboard</p>
                  <p className="text-xs opacity-90">Quick Access</p>
                </div>
                <ArrowRight className="w-5 h-5 text-white" />
              </div>
            </CardContent>
          </Card>
        </Link>
      </div>
    );
  }

  return null;
};